import { createContext, useContext, ReactNode } from "react";
import type { CustomerBasketAdapter } from "./customer-basket-adapter";

// Null in a build with no basket (the real portal until PO-3, the staff view): every basket entry point
// (the nav item, Add to basket, Order again) hides itself rather than offering what cannot be done.
const CustomerBasketAdapterContext =
  createContext<CustomerBasketAdapter | null>(null);

export function CustomerBasketAdapterProvider({
  adapter,
  children,
}: {
  adapter: CustomerBasketAdapter | null;
  children: ReactNode;
}) {
  return (
    <CustomerBasketAdapterContext.Provider value={adapter}>
      {children}
    </CustomerBasketAdapterContext.Provider>
  );
}

/** The basket adapter, or null where the build has no basket. */
export function useOptionalCustomerBasketAdapter(): CustomerBasketAdapter | null {
  return useContext(CustomerBasketAdapterContext);
}

/** The basket adapter; throws where there is none (the basket pages are only routed when there is). */
export function useCustomerBasketAdapter(): CustomerBasketAdapter {
  const adapter = useContext(CustomerBasketAdapterContext);
  if (!adapter) {
    throw new Error(
      "useCustomerBasketAdapter must be used within a CustomerBasketAdapterProvider with an adapter",
    );
  }
  return adapter;
}
